import { AccuracyAuthorizationEnum, AuthorizationStatusEnum, TrackingSourceEnum } from './types';
export const availableLoads = [
    {
        loadDetails: {
            rate: 1500,
            weight: '20,000 lbs',
            equipment: 'Dry Van',
            destinationAppointmentDate: (Date.now() + 259200),
            destinationCity: 'Fort Worth, TX',
            details: '1 Pick, 1 Drop'
        },
        coordinates: {
            latitude: 38.792434,
            longitude: -81.341956
        },
        warehouseImage: 'https://www.google.com/maps/place/Armacell+Spencer+Warehouse/@38.7927317,-81.3382492,3a,75y,90t/data=!3m8!1e2!3m6!1sAF1QipN4Ku3P-z_NdgKTPiJGJVMxYVtWTgJRiiyDXDHf!2e10!3e12!6shttps:%2F%2Flh5.googleusercontent.com%2Fp%2FAF1QipN4Ku3P-z_NdgKTPiJGJVMxYVtWTgJRiiyDXDHf%3Dw203-h152-k-no!7i4032!8i3024!4m13!1m5!3m4!2zMzjCsDQ3JzMyLjgiTiA4McKwMjAnMzEuMCJX!8m2!3d38.792434!4d-81.341956!3m6!1s0x884911f557a03045:0x7ff95ef11afc2511!8m2!3d38.7927317!4d-81.3382492!10e5!16s%2Fg%2F11h7g5pp8f?entry=ttu#'
    },
    {
        loadDetails: {
            rate: 1800,
            weight: '40,000 lbs',
            equipment: 'Dry Van',
            destinationAppointmentDate: (Date.now() + 259200),
            destinationCity: 'Dallas, TX',
            details: '1 Pick, 1 Drop'
        },
        coordinates: {
            latitude: 40.399866,
            longitude: -79.922614
        }
    },
    {
        loadDetails: {
            rate: 1600,
            weight: '20,000 lbs',
            equipment: 'Dry Van',
            destinationAppointmentDate: (Date.now() + 345600),
            destinationCity: 'Lubbock, TX',
            details: '1 Pick, 1 Drop'
        },
        coordinates: {
            latitude: 35.62092,
            longitude: -78.803571
        }
    }
];
export const stops = [
    {
        id: '1-pick',
        sequence: 1,
        type: 'Pick',
        warehouse: {
            name: 'Lockheed Martin',
            address: {
                addressLabel: 'Lockheed Martin',
                boundingBox: ['-97.460324', '32.765413', '-97.444295', '32.783996'],
                city: 'Fort Worth',
                coordinates: {
                    latitude: 32.772266,
                    longitude: -97.44997
                },
                postalCode: '76108',
                stateCode: 'TX',
                street: 'Lockheed Boulevard',
                streetNumber: '1',
                geofence: {
                    geometry: {
                        coordinates: [
                            [
                                [-97.4457303, 32.7654872],
                                [-97.4443195, 32.7655504],
                                [-97.4441492, 32.7771531],
                                [-97.4469709, 32.7770899],
                                [-97.4470031, 32.780211],
                                [-97.447164, 32.780229],
                                [-97.4472713, 32.7808785],
                                [-97.448955, 32.7808748],
                                [-97.4489657, 32.782291],
                                [-97.4507888, 32.7822299],
                                [-97.4508532, 32.7793704],
                                [-97.4511322, 32.7792802],
                                [-97.452999, 32.779181],
                                [-97.4528059, 32.7779542],
                                [-97.4526127, 32.7772506],
                                [-97.4531921, 32.7762674],
                                [-97.4538549, 32.7738481],
                                [-97.4545133, 32.7720662],
                                [-97.4556398, 32.7710378],
                                [-97.456998, 32.7701032],
                                [-97.4585859, 32.7690568],
                                [-97.4597272, 32.7682375],
                                [-97.4602207, 32.7672361],
                                [-97.4602314, 32.7654678],
                                [-97.445726, 32.7654227],
                                [-97.4456938, 32.7655039]
                            ]
                        ],
                        type: 'Polygon'
                    },
                    id: 'stop-1-lockheed',
                    properties: {
                        id: 1,
                        name: 'lockheed'
                    },
                    type: 'Feature'
                }
            }
        }
    },
    {
        id: '1-drop',
        sequence: 2,
        type: 'Drop',
        warehouse: {
            name: 'Pentagon',
            address: {
                addressLabel: 'Pentagon',
                boundingBox: ['38.791653', '38.99596', '-77.119759', '-76.909155'],
                city: 'Washington',
                coordinates: {
                    latitude: 38.82652,
                    longitude: -77.01712
                },
                postalCode: '20032',
                stateCode: 'District of Columbia',
                street: 'Army Pentagon',
                streetNumber: '101'
            }
        }
    }
];
export const currentLocationArrivedOrigin = {
    location: {
        coordinates: {
            latitude: 32.76716,
            longitude: -97.445906
        },
        locationInfo: {
            activity: {
                confidence: 100,
                type: 'in_vehicle'
            },
            batteryLevel: 0.64,
            isMockLocation: false,
            isMoving: true,
            locationID: '123456789',
            locationSettings: {
                accuracyAuthorization: AccuracyAuthorizationEnum.AccuracyAuthorizationFull,
                authorizationStatus: AuthorizationStatusEnum.AuthorizationStatusAlways,
                gpsGeolocationProviderAvailable: true,
                locationServicesEnabled: true,
                networkGeolocationProviderAvailable: true
            }
        },
        timestamp: (Date.now() - 60000)
    },
    locationSourceMetadata: {
        deviceID: '123456789',
        deviceInfo: {
            deviceID: '123456789',
            batteryLevel: 0.64,
            deviceManufacturer: 'Apple',
            deviceModel: 'iPhone13,4',
            deviceName: "Jane's iPhone",
            deviceOS: 'ios',
            deviceOSVersion: '15.0',
            devicePlatform: 'ios',
            isDeviceCharging: true,
            isDeviceVirtual: false,
            languageCode: 'ru'
        },
        hasSentMockLocations: false,
        isHistoricalDevice: false,
        locationSettings: {
            accuracyAuthorization: AccuracyAuthorizationEnum.AccuracyAuthorizationFull,
            authorizationStatus: AuthorizationStatusEnum.AuthorizationStatusAlways,
            gpsGeolocationProviderAvailable: true,
            locationServicesEnabled: true,
            networkGeolocationProviderAvailable: true
        },
        user: { id: '123', name: 'Patriot Trucking' }
    },
    sequence: 9,
    source: TrackingSourceEnum.MobileApp
};
export const currentLocation = {
    location: {
        coordinates: {
            latitude: 37.126029,
            longitude: -80.378831
        },
        locationInfo: {
            activity: {
                confidence: 100,
                type: 'in_vehicle'
            },
            batteryLevel: 0.64,
            isMockLocation: false,
            isMoving: true,
            locationID: '123456789',
            locationSettings: {
                accuracyAuthorization: AccuracyAuthorizationEnum.AccuracyAuthorizationFull,
                authorizationStatus: AuthorizationStatusEnum.AuthorizationStatusAlways,
                gpsGeolocationProviderAvailable: true,
                locationServicesEnabled: true,
                networkGeolocationProviderAvailable: true
            }
        },
        timestamp: (Date.now() - 60000)
    },
    locationSourceMetadata: {
        deviceID: '123456789',
        deviceInfo: {
            deviceID: '123456789',
            batteryLevel: 0.64,
            deviceManufacturer: 'Apple',
            deviceModel: 'iPhone13,4',
            deviceName: "Jane's iPhone",
            deviceOS: 'ios',
            deviceOSVersion: '15.0',
            devicePlatform: 'ios',
            isDeviceCharging: true,
            isDeviceVirtual: false,
            languageCode: 'ru'
        },
        hasSentMockLocations: false,
        isHistoricalDevice: false,
        locationSettings: {
            accuracyAuthorization: AccuracyAuthorizationEnum.AccuracyAuthorizationFull,
            authorizationStatus: AuthorizationStatusEnum.AuthorizationStatusAlways,
            gpsGeolocationProviderAvailable: true,
            locationServicesEnabled: true,
            networkGeolocationProviderAvailable: true
        },
        user: { id: '123', name: 'Patriot Trucking' }
    },
    sequence: 9,
    source: TrackingSourceEnum.MobileApp
};
export const routeLineCoordinates = [
    [-80.378831, 37.126029],
    [-80.692432, 37.078818],
    [-80.868504, 36.95303],
    [-81.062044, 36.960044],
    [-81.877874, 36.751322],
    [-83.381806, 36.07228],
    [-83.590838, 35.985531],
    [-83.859425, 36.013589],
    [-84.251313, 35.871653],
    [-84.817811, 35.883513],
    [-85.272793, 36.140365],
    [-85.724576, 36.090051],
    [-86.203061, 36.194403],
    [-86.723636, 36.14051],
    [-86.727027, 36.131113],
    [-86.82253, 36.153394],
    [-87.66376, 35.885625],
    [-88.360798, 35.79859],
    [-89.252368, 35.537476],
    [-89.880037, 35.156077],
    [-89.881975, 35.154511],
    [-90.020079, 35.161202],
    [-90.189836, 35.170453],
    [-91.340724, 34.851524],
    [-92.154613, 34.782145],
    [-92.157935, 34.782155],
    [-92.67498, 34.536812],
    [-93.223117, 33.957708],
    [-94.091508, 33.454445],
    [-94.446073, 33.475544],
    [-95.03651, 33.158506],
    [-96.072877, 33.13579],
    [-96.618863, 32.829669],
    [-96.625708, 32.825721],
    [-96.67417, 32.800905],
    [-96.697858, 32.793989],
    [-96.722422, 32.794311],
    [-96.76064, 32.790343],
    [-96.771462, 32.78089],
    [-96.787652, 32.775199],
    [-96.804991, 32.768752],
    [-96.815254, 32.770911],
    [-96.914926, 32.766095],
    [-97.06329, 32.759335],
    [-97.214065, 32.759922],
    [-97.267227, 32.755783],
    [-97.321285, 32.745291],
    [-97.334492, 32.744508],
    [-97.358157, 32.734463],
    [-97.368786, 32.732321],
    [-97.396945, 32.733028],
    [-97.42636, 32.7347],
    [-97.447326, 32.738297],
    [-97.451812, 32.738583],
    [-97.451712, 32.739773],
    [-97.445656, 32.740197],
    [-97.445956, 32.765345]
];
